import { render, staticRenderFns } from "./visualizar-ranfs.vue?vue&type=template&id=59f20c6a&"
import script from "./visualizar-ranfs.vue?vue&type=script&lang=js&"
export * from "./visualizar-ranfs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports